import { extendDecorator } from '@/js/common/Domain/Service/mixins/decorators';

import template from './assets/template.html';

@extendDecorator({
    template,
    el: '<li></li>',
    events: {
        'change input': 'resortToggle',
    },
    $countryCheckbox: null,
})
export default class extends Backbone.View {
    render() {
        const $countryCheckbox = $(this.template({
            resort: this.model,
        }));

        this.$countryCheckbox = $('input', $countryCheckbox);
        this.$el.html($countryCheckbox);
    }

    resortToggle(event) {
        const currentValue = $(event.target).is(':checked');

        if (currentValue) {
            this.selectedResortsCollection.add(this.model);
            return;
        }

        this.selectedResortsCollection.remove(this.model);
    }

    initialize(options) {
        this.render();
        this.selectedResortsCollection = options.selectedResortsCollection;
    }
}